// @flow

import React, { Component, Fragment, type Element } from 'react';
//types
import { Default } from '../../../components/Responsive';
import DefaultModelRowTr from './DefaultModelRowTr';

type Props = {
  options: {
    col1: Element<any>,
    col2: Element<any>,
    col3: Element<any>,
    col4: Element<any>
  },
  id: number
};

export default class TableRowPartial extends Component<Props> {
  render() {
    return (
      <Fragment key={this.props.id}>
        <DefaultModelRowTr>
          <Default>{this.props.options.col1}</Default>
          {this.props.options.col2}
          {this.props.options.col3}
          <Default>{this.props.options.col4}</Default>
        </DefaultModelRowTr>
      </Fragment>
    );
  }
}
